export enum JobBoardTab {
    activeJobs = "activeJobs",
    inactiveJobs = "inactiveJobs",
}

export enum JobStatus {
    posted,
    approved ,
    removed,
    expired
}
